import { MTServiceKeywordTable } from './MTServiceKeywordTable'

/**
 * MTServiceKeywordPage - Renders the Service Keyword table component.
 * Route: define/SERVICE_KEYWORD
 */
export function MTServiceKeywordPage() {
  return <MTServiceKeywordTable />
}
